import React from 'react';
import { HardHat, Hammer, ChevronLeft, Construction } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ConstruccionWidget = ({ 
  titulo = "Sección en Construcción", 
  mensaje = "Estamos trabajando arduamente para darte la mejor experiencia. ¡Vuelve pronto!",
  mostrarBotonRegresar = true 
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[400px] w-full flex-col items-center justify-center bg-gray-50 p-6 text-center">
      {/* Contenedor del Icono con efecto de rebote */}
      <div className="relative mb-6">
        <div className="absolute -inset-1 rounded-full bg-yellow-400 opacity-25 animate-ping"></div>
        <div className="relative bg-white p-6 rounded-full shadow-xl border-4 border-yellow-400">
          <HardHat size={60} className="text-yellow-600 animate-bounce" />
        </div>
        {/* Herramienta secundaria flotante */}
        <Hammer size={24} className="absolute -right-2 -bottom-2 text-gray-400 rotate-12" />
      </div>

      {/* Franja Estilo Cinta de Precaución */}
      <div className="mb-6 flex overflow-hidden rounded-full bg-yellow-400 px-4 py-1 shadow-sm">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="flex items-center gap-4">
            <span className="text-[10px] font-black uppercase tracking-widest text-black/80">
              Precaución
            </span>
            <Construction size={12} className="text-black/80" />
          </div>
        ))}
      </div>

      {/* Contenido de Texto */}
      <div className="max-w-md">
        <h1 className="text-3xl font-black text-gray-900 uppercase tracking-tight mb-3">
          {titulo}
        </h1>
        <p className="text-gray-500 leading-relaxed">
          {mensaje}
        </p>
      </div>

      {/* Botón de acción opcional */}
      {mostrarBotonRegresar && (
        <button
          onClick={() => navigate(-1)}
          className="mt-8 flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-xl font-bold hover:bg-gray-800 transition-all active:scale-95 shadow-lg group"
        >
          <ChevronLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
          VOLVER ATRÁS
        </button>
      )}

      {/* Detalle decorativo inferior */}
      <div className="mt-12 flex gap-2">
        <div className="h-1.5 w-8 rounded-full bg-yellow-400"></div>
        <div className="h-1.5 w-16 rounded-full bg-gray-200"></div>
        <div className="h-1.5 w-8 rounded-full bg-yellow-400"></div>
      </div>
    </div>
  );
};

export default ConstruccionWidget;